export default __webpack_public_path__ + "static/media/handloomcarpet.52914eb4.jpg";